import { useSearchParams } from "react-router-dom";

import useAllPricing from "features/subscriptions/datahooks/useAllPricing";
import { getPricingPeriodValue } from "features/subscriptions/utils";

import type {
  AgencySubscription,
  Pricing,
  RentedSubscription,
  Subscription,
  SubscriptionType,
} from "common/types";

export default function usePricingOptions(
  subscriptionType: SubscriptionType,
  currentSubscription: Subscription | AgencySubscription | RentedSubscription,
) {
  const { allPricing } = useAllPricing();
  const [searchParams] = useSearchParams();

  const pricingOptions = allPricing
    ? allPricing
        .filter(({ id, subscription_type, period, period_unit }) => {
          if (
            currentSubscription?.item_price.period_unit === period_unit &&
            currentSubscription?.item_price.period === period
          ) {
            return currentSubscription.item_price.id === id;
          }
          return subscription_type === subscriptionType;
        })
        .reduce(
          (accumulator, currentItem) => {
            if (currentItem.item_type === "plan") {
              const addon = allPricing.find(
                ({ item_type, period_unit, period, subscription_type }) =>
                  item_type === "addon" &&
                  period_unit === currentItem.period_unit &&
                  period === currentItem.period &&
                  subscription_type === currentItem.subscription_type,
              );
              if (addon) {
                accumulator.push({
                  plan: currentItem,
                  addon,
                });
              }
            }
            return accumulator;
          },
          [] as { addon: Pricing; plan: Pricing }[],
        )
        .filter(({ plan }) => {
          const planIdParam = searchParams.get("planId");
          return (
            plan.visible ||
            currentSubscription?.item_price.id === plan.id ||
            (planIdParam && plan.id === planIdParam)
          );
        })
        .sort((option1, option2) => {
          return (
            getPricingPeriodValue(option1.plan) -
            getPricingPeriodValue(option2.plan)
          );
        })
    : [];

  return { pricingOptions };
}
